<template>
  <div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info ">
        <span>客户姓名：</span>
        <el-input class="searchInput" v-model="customerName"></el-input>
      </div>
      <div class="fill-in-info">
        <span>员工：</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-input style="width: 8rem" :disabled="true" class="rt-input"
        v-model="staff"
        ></el-input>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span >所属部门：</span>
        <el-input style="width:11rem" :disabled="true" class="rt-input"
        v-model="department"
        ></el-input>
      </div>
    </div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info">
        <span>客户性别：</span>
        <el-select v-model="sex" class="searchInput">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.sex"
          ></el-option>
        </el-select>
      </div>
      <div class="fill-in-info">
        <span>联系电话：</span>
        <el-input class="searchInput" v-model="tel"></el-input>
      </div>
    </div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info">
        <span>证件类型：</span>
        <el-select
          v-model="IDTypeId"
          class="searchInput">
          <el-option
            v-for="item in IDType"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="fill-in-info">
        <span>证件号码：</span>
        <el-input class="searchInput" v-model="IDCode"></el-input>
      </div>
    </div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info">
        <span>出生日期：</span>
        <el-date-picker
          class="searchInput"
          type="date"
          v-model="birthDt"
          placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="fill-in-info">
        <span>年龄：</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-input class="searchInput" v-model="age" type="number"></el-input>
      </div>
    </div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info">
        <span>工作单位：</span>
        <el-input class="searchInput" v-model="unit"></el-input>
      </div>
      <div class="fill-in-info">
        <span>通讯地址：</span>
        <el-input class="searchInput" v-model="address"></el-input>
      </div>
    </div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info">
        <span>客户类型：</span>
        <el-select
          v-model="custType"
          class="searchInput">
          <el-option
            v-for="item in custTypes"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="fill-in-info">
        <span>客户来源：</span>
        <el-select
          v-model="source"
          class="searchInput">
          <el-option
            v-for="item in coustSource"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="fill-in-info bottom-part">
      <div class="fill-in-info">
        <span>备注：</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <el-steps direction="vertical" v-if="remarks && remarks.length > 0">
            <el-step v-for="remark in remarks"
                     :key="remark.id"
                     :title="remark.content"
                     :description="
                        (remark.updateDt ? remark.updateDt  : remark.entryDt) | dateFormat
                       "></el-step>
          </el-steps>
      </div>
    </div>
    <button class="hold"
    @click="holdInfo"
    >保存信息</button>
  </div>

</template>

<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";

export default {
  name: "BasicCostInfo",
  data(){
    return{
      id:'',
      customerName:'',
      staff:'',
      tel:'',
      options: [{
        sex: 1,
        label: '男'
      }, {
        sex: 2,
        label: '女'
      }],
      sex:'',
      department:'',
      age:'',
      //证件类型
      IDType:[],
      IDTypeId:'',
      IDCode:'',
      remarks:[],
      unit:'',
      address:'',
      coustSource:[],
      source:'',
      custTypes:[],
      custType:'',
      birthDt:'',
      basicInfo:{}
    }
  },
  created() {
    this.init()

    //监听游览器后退事件
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },



  methods:{
    //获取需要类型
    getIdType(){
      axios.post(`${ipAddress.qi}/admin/a1/commons/getCustomerType`).then(
        value => {
          const content = value.content;
          this.IDType = content.psptType;
          this.coustSource = content.source
          this.custTypes = content.type
        }
      )
    },

    //保存信息
    holdInfo(){
      if(!this.customerName){
        Message.warning("客户姓名不能为空！")
        return
      }
      if(!this.sex){
        Message.warning("请选择客户性别！")
        return;
      }
      if(!this.tel){
        Message.warning("请填写对应的手机号！")
        return;
      }

      //判断是否修改过数据
      if(!((this.customerName == this.basicInfo.name)
         && (this.sex == this.basicInfo.sex)
         && (this.tel == this.basicInfo.telNumber)
         && (this.IDTypeId == this.basicInfo.idType)
         && (this.IDCode == this.basicInfo.idCard)
         && (this.birthDt == this.basicInfo.birthDt)
         && (this.age == this.basicInfo.age)
         && (this.unit == this.basicInfo.company)
         && (this.address == this.basicInfo.address)
         && (this.source == this.basicInfo.source)
         && (this.custType == this.basicInfo.type)
       )){
         const params = {
           id:this.id,
           name:this.customerName,
           sex:this.sex,
           telNumber:this.tel,
           idType:this.IDTypeId,
           idCard:this.IDCode,
           birthDt:this.birthDt,
           age:this.age,
           company:this.unit,
           address:this.address,
           source:this.source,
           type:this.custType,
         }
         axios.post(`${ipAddress.qi}/admin/a1/customer/upBasicById`,
           params,
           true
           )
        .then(value =>{
           const content = value.content
           const msg = value.message
           if(content){
              Message.success("保存成功！")
           }else {
              Message.warning(msg)
           }
        }).catch(error =>{
           Message.error(JSON.stringify(error))
        })
      }
    },
    //初始化数据
    init(){
      this.getIdType()

      const id = this.$route.params.id
      this.id = id
      let params = new URLSearchParams()
      params.set("id",`${id}`)
      axios.post(`${ipAddress.qi}/admin/a1/customer/getBasicById`,params).then(
        value =>{

          const content = value.content
          this.basicInfo = content
          this.customerName = content.name;
          this.staff = content.staffName;
          this.tel = content.telNumber;
          this.sex = content.sex;
          this.department = content.departmentName;
          const age = content.age;
          if(age){
            this.age = age;
          }
          this.IDTypeId = content.idType;
          this.IDCode = content.idCard;
          this.remarks = content.remarks;
          this.unit = content.company;
          this.address = content.address;
          this.source = content.source;
          this.custType = content.type;
          this.birthDt = new Date(content.birthDt);
        }
      )
    }
  },
  watch:{
    $route:{
      handler(from,to){
        const fromId = from.params.id
        const  toId = to.params.id
        if(!(fromId == toId)){
          this.init()
        }
      }
    }
  }
}
</script>

<style scoped>

.fill-in-info{
  display: flex;
  width:auto;
  font-size: 0.85rem;
  height:auto;
  letter-spacing: 1px;
  margin:0.5rem 2rem 0 1rem ;
  align-items: center;
}
.searchInput{
  width: 25rem;
}
.bottom-part{
  margin-bottom: 1rem;
}
.remark{
  width: 57.5rem;
  height: 10rem;
  background-color: white;
  border-radius: 5px;
  border:1px solid #DCDFE6;
  margin-bottom: 1rem;
  outline:none;
  padding:0.5rem
}
.hold{
  padding:0.8rem 1.5rem;
  background-color: #0f86da;
  font-size: 0.95rem;
  letter-spacing:2px;
  color: white;
  border-radius: 8px;
  border: none;
  margin-left: 6.5rem;
  margin-bottom: 2rem;
}
.rt-input  /deep/ .el-input__inner{
  background-color: rgba(190,190,190,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/BasicCostInfo.vue